<div class="container">
  <mat-card>
    <form [formGroup]="createEntityForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Entity' | translate }}</mat-label>
            <mat-select required formControlName="entity">
              @for (entity of entityTypes; track entity) {
                <mat-option [value]="entity.value">
                  {{ entity.name }}
                </mat-option>
              }
            </mat-select>
            @if (createEntityForm.controls.entity.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Entity' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Status' | translate }}</mat-label>
            <mat-select required formControlName="status">
              @for (status of statusList; track status) {
                <mat-option [value]="status.code">
                  {{ status.name }}
                </mat-option>
              }
            </mat-select>
            @if (createEntityForm.controls.status.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Status' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Data Table' | translate }}</mat-label>
            <mat-select required formControlName="datatableName">
              @for (dataTable of dataTableList; track dataTable) {
                <mat-option [value]="dataTable.dataTableName">
                  {{ dataTable.dataTableName }}
                </mat-option>
              }
            </mat-select>
            @if (createEntityForm.controls.datatableName.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Data Table' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          @if (entityType === 'm_loan') {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Products' | translate }}</mat-label>
              <mat-select required formControlName="productId">
                @for (loanProducts of createEntityData.loanProductDatas; track loanProducts) {
                  <mat-option [value]="loanProducts.id">
                    {{ loanProducts.name }}
                  </mat-option>
                }
              </mat-select>
              @if (createEntityForm.controls.productId.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Loan Product' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          @if (entityType === 'm_savings_account') {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Products' | translate }}</mat-label>
              <mat-select required formControlName="productId">
                @for (savingsProducts of createEntityData.savingsProductDatas; track savingsProducts) {
                  <mat-option [value]="savingsProducts.id">
                    {{ savingsProducts.name }}
                  </mat-option>
                }
              </mat-select>
              @if (createEntityForm.controls.productId.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Loan Product' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!createEntityForm.valid">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
